import { FEATURE_IDS } from "@/config/products";

/**
 * Determines the primary credit feature ID based on user subscription
 * Note: Users may also have CREDIT_TOP_UP as an additional credit source
 * @param hasPro - Whether the user has a pro subscription
 * @param isAdvancedModel - Whether the model is an advanced model
 * @returns The primary feature ID or null if the combination is not allowed
 */
export function getFeatureId(hasPro: boolean, isAdvancedModel: boolean): string | null {
  if (!hasPro) {
    // Free users can only use CREDIT_FREE (non-advanced models)
    if (isAdvancedModel) {
      // Free users cannot use advanced models
      return FEATURE_IDS.CREDIT_TOP_UP;
    }
    return FEATURE_IDS.CREDIT_FREE;
  }

  // Pro users use CREDIT_PRO which contains both base_paid and pro_paid metered features
  return FEATURE_IDS.CREDIT_PRO;
}
